import { createAsyncThunk } from "@reduxjs/toolkit";
import { getGroups } from "domain/groups/api/get-groups";
import { GroupsRequestDto } from "domain/groups/entities/dtos/groups-request.dto";

export const getGroupsAction = createAsyncThunk(
  "groups/getGroupsAction",
  async ({ accountId }: GroupsRequestDto) => {
    try {
      return await getGroups({ accountId });
    } catch (e: any) {
      console.error(e);
      throw new Error(e);
    }
  }
);
